var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.45 11.2C8.4 11.2 6.8 9.2 6.8 6.85C6.8 4.42 8.44 2.6 10.45 2.6C12.47 2.6 14.1 4.42 14.1 6.85C14.1 9.2 12.5 11.2 10.45 11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 19.25C3.4 15.95 6.3 13.6 10.5 13.6C11.8 13.6 13 13.82 14.02 14.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15 19.25C6.55 17.38 8.2 16.1 10.5 16.1C11.15 16.1 11.74 16.2 12.27 16.39",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15 13.2L18.55 14.25L19.6 14.65L18.55 15.05L18.15 16.1L17.75 15.05L16.7 14.65L17.75 14.25L18.15 13.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.15,
    cy: 18.1,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15 14.45V13.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15 22.95V21.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8 18.1H23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 18.1H14.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 15.5L21.6 14.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 21.55L15.55 20.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 20.7L21.6 21.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 14.65L15.55 15.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.15,
    cy: 18.1,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminOptions);
export default __webpack_public_path__ + "static/media/adminOptions.fd3657b94118db349844244d83575e92.svg";
export { ForwardRef as ReactComponent };